export default __webpack_public_path__ + "static/media/Averta-Extra-Bold.abf7c99b.woff";